import React, { Component, ReactNode } from 'react';
import { handleChunkError, isChunkError } from '@utils/chunkErrorHandler';
import styles from './ChunkErrorBoundary.module.scss';
import { getGlobalIntl } from '../../i18n/ProviderIntl';

interface Props {
  children: ReactNode;
}

interface State {
  hasError: boolean;
  isReloading: boolean;
}

class ChunkErrorBoundary extends Component<Props, State> {
  constructor(props: Props) {
    super(props);
    this.state = {
      hasError: false,
      isReloading: false,
    };
  }

  static getDerivedStateFromError(error: Error): State | null {
    // Обновляем состояние, чтобы показать fallback UI при следующем рендере
    if (isChunkError(error)) {
      return { hasError: true, isReloading: true };
    }
    return null;
  }

  componentDidCatch(error: Error, errorInfo: React.ErrorInfo): void {
    console.error('ChunkErrorBoundary caught an error:', error, errorInfo);

    if (isChunkError(error)) {
      // Небольшая задержка чтобы пользователь увидел сообщение
      setTimeout(() => {
        handleChunkError(error);
      }, 1500);
    }
  }

  render() {
    const { formatMessage } = getGlobalIntl();
    if (this.state.hasError && this.state.isReloading) {
      return (
        <div className={styles.container}>
          <div className={styles.spinner}></div>
          <h2 className={styles.title}>{formatMessage({ id: "chunk_error_boundary.title" })}</h2>
          <p className={styles.text}>{formatMessage({ id: "chunk_error_boundary.text" })}</p>
        </div>
      );
    }

    return this.props.children;
  }
}

export default ChunkErrorBoundary;
